<template>
    <div class="image-grid">
        <img
            :style="{ width: `${imageGrid.width}px`, height: `${imageGrid.height}px`, 'user-select': 'none' }"
            :src="imageGrid.image">
        <template v-for="(room, index) in imageGrid.rooms">
            <div
                :key="index"
                :style="{ width: `${room.width}px`, height: `${room.height}px`, top: `${room.top_offset}px`, left: `${room.left_offset}px` }"
                :class="{ available: room.reserve_status_id === 1 }"
                class="overlay">
                <template v-if="room.reserve_status_id === 1">
                    <v-layout justify-center class="align-center fill-height layout-available">
                        <v-flex @click="onBookingRoom(room)"
                                class="bookBtn text-center"
                                v-ripple
                                shrink>
                            Book <br> Now
                        </v-flex>
                    </v-layout>
                </template>
                <template v-if="room.reserve_status_id !== 1">
                    <v-layout justify-center class="align-center fill-height layout-reserved">
                    </v-layout>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: 'image-grid',
        props: ['expectWidth', 'imageData'],
        computed: {
            imageGrid: function () {
                const factor = this.imageData.width / parseInt(this.expectWidth);

                const imageGrid = {
                    ...this.imageData,
                    width: this.imageData.width / factor,
                    height: this.imageData.height / factor,
                    rooms: this.imageData.rooms.map(room => ({
                        ...room,
                        top_offset: room.top_offset / factor,
                        left_offset: room.left_offset / factor,
                        width: room.width / factor,
                        height: room.height / factor,
                    }))
                }

                return imageGrid
            }
        },
        methods: {
            ...mapActions('roomSelected', ['setSelectedRoom']),
            async onBookingRoom(room) {
                await this.setSelectedRoom(room);
                this.$vuetify.goTo('#room-info');
            }
        }
    }
</script>

<style lang="scss" scoped>

    .image-grid {
        overflow: auto;
        position: relative;
        .overlay {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            &.available {
                background-color: rgba(255, 255, 255, 0.7);
                border: unset;
            }
        }
    }

    .bookBtn {
        line-height: 1;
        padding: 12px;
        cursor: pointer;
        border-radius: 15px;
        background: rgb(233, 155, 7);
        box-shadow: 0 4px 3px rgba(0, 0, 0, .5)
    }

    .layout-available {
        border: solid 2px rgb(233, 155, 7);
    }

    .layout-reserved {
        border: solid 2px #ff2a00;
        background: linear-gradient(to top left,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) calc(50% - 0.8px),
            #ff2a00 49%,
            #ff2a00 50%,
            #ff2a00 51%,
            rgba(0,0,0,0) calc(50% + 0.8px),
            rgba(0,0,0,0) 100%);;
    }

</style>
